import { IAnimationPreset } from "../../app/interfaces";

export const PlayAnimations: Array<IAnimationPreset> = [
    {
        "animation": {"$": {"enabled": "1", "duration": "1000", "frequency": "1", "rotateFrq": "0", "rotateValue": "45", "fadeFrq": "1", "scaleFrq": "0", "scaleValue": "1.5"}},
        "image": "play_flash.gif",
        "name": "Flash",
        "mode": "Play"
    },
    {
        "animation": {"$": {"enabled": "1", "duration": "1000", "frequency": "1", "rotateFrq": "1", "rotateValue": "45", "fadeFrq": "0", "scaleFrq": "0", "scaleValue": "1.5"}},
        "image": "play_rotate.gif",
        "name": "Rotate",
        "mode": "Play"
    },
    {
        "animation": {"$": {"enabled": "1", "duration": "1000", "frequency": "1", "rotateFrq": "1", "rotateValue": "45", "fadeFrq": "1", "scaleFrq": "0", "scaleValue": "1.5"}},
        "image": "play_rotate_flash.gif",
        "name": "Rotate Flash",
        "mode": "Play"
    },
    {
        "animation": {"$": {"enabled": "1", "duration": "1000", "frequency": "1", "rotateFrq": "1", "rotateValue": "45", "fadeFrq": "0", "scaleFrq": "1", "scaleValue": "1.5"}},
        "image": "play_rotate_scale.gif",
        "name": "Rotate Scale",
        "mode": "Play"
    },
    {
        "animation": {"$": {"enabled": "1", "duration": "1000", "frequency": "1", "rotateFrq": "0", "rotateValue": "45", "fadeFrq": "1", "scaleFrq": "1", "scaleValue": "1.5"}},
        "image": "play_flash_scale.gif",
        "name": "Flash Scale",
        "mode": "Play"
    },
    {
        "animation": {"$": {"enabled": "1", "duration": "1000", "frequency": "1", "rotateFrq": "0", "rotateValue": "45", "fadeFrq": "1", "scaleFrq": "0", "scaleValue": "1.5"}},
        "image": "play_scale.gif",
        "name": "Scale",
        "mode": "Play"
    },
    {
        "animation": {"$": {"enabled": "1", "duration": "1000", "frequency": "1", "rotateFrq": "1", "rotateValue": "45", "fadeFrq": "1", "scaleFrq": "1", "scaleValue": "1.5"}},
        "image": "play_rotate_blink.gif",
        "name": "Rotate Blink",
        "mode": "Play"
    },
    {
        "animation": {"$": {"enabled": "1", "duration": "1000", "frequency": "6.6", "rotateFrq": "1", "rotateValue": "45", "fadeFrq": "0", "scaleFrq": "0", "scaleValue": "1.5"}},
        "image": "play_fast_shake.gif",
        "name": "Fast Shake",
        "mode": "Play"
    },
    {
        "animation": {"$": {"enabled": "1", "duration": "1000", "frequency": "6.6", "rotateFrq": "0", "rotateValue": "45", "fadeFrq": "1", "scaleFrq": "0", "scaleValue": "1.5"}},
        "image": "play_blinkers.gif",
        "name": "Blinkers",
        "mode": "Play"
    },
    {
        "animation": {"$": {"enabled": "1", "duration": "1000", "frequency": "6.6", "rotateFrq": "0", "rotateValue": "45", "fadeFrq": "0", "scaleFrq": "1", "scaleValue": "1.5"}},
        "image": "play_quake.gif",
        "name": "Quake",
        "mode": "Play"
    },
    {
        "animation": {"$": {"enabled": "1", "duration": "1000", "frequency": "6.6", "rotateFrq": "0", "rotateValue": "45", "fadeFrq": "1", "scaleFrq": "1", "scaleValue": "1.5"}},
        "image": "play_flash_quake.gif",
        "name": "Flash Quake",
        "mode": "Play"
    },
    {
        "animation": {"$": {"enabled": "1", "duration": "1000", "frequency": "0.4", "rotateFrq": "0", "rotateValue": "45", "fadeFrq": "1", "scaleFrq": "0", "scaleValue": "1.5"}},
        "image": "play_slow_flash.gif",
        "name": "Slow Flash",
        "mode": "Play"
    }
];

export const InAnimations: Array<IAnimationPreset> = [
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "0", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_in.gif",
        "name": "Fade In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "enter_stage_left.gif",
        "name": "Enter Stage Left",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "180", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "enter_stage_right.gif",
        "name": "Enter Stage Right",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "90", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "descend_from_above.gif",
        "name": "Decsend from Above",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "270", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "rise_from_below.gif",
        "name": "Rise from Below",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "45", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "enter_stage_upper_left_corner.gif",
        "name": "Enter Stage Upper Left Corner",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "135", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "enter_stage_upper_right_corner.gif",
        "name": "Enter Stage Upper Right  Corner",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "315", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "enter_stage_lower_left_corner.gif",
        "name": "Enter Stage Lower Left Corner",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "225", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "ernter_stage_lower_right_corner.gif",
        "name": "Enter Stage Lower Right Corner",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "90", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_in_from_top.gif",
        "name": "Fade In from Top",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "270", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_in_from_bottom.gif",
        "name": "Fade In from Bottom",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_in_from_left.gif",
        "name": "Fade In from Left",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "180", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_in_from_right.gif",
        "name": "Fade In from Right",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "45", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_in_from_ne.gif",
        "name": "Fade In from NE",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "135", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_in_from_nw.gif",
        "name": "Fade In from NW",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "315", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_in_from_se.gif",
        "name": "Fade In from SE",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "225", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_in_from_sw.gif",
        "name": "Fade In from SW",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "0", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "-2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "spiral_in_clockwise.gif",
        "name": "Spiral In Clockwise",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "0", "rotateFrq": "1", "rotateType": "fixed", "rotations": "-2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "roll_in_from_left.gif",
        "name": "Roll In from Left",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "180", "scaleFrq": "0", "rotateFrq": "1", "rotateType": "fixed", "rotations": "2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "roll_in_from_right.gif",
        "name": "Roll In from Right",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "90", "scaleFrq": "0", "rotateFrq": "1", "rotateType": "fixed", "rotations": "-2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "yoyo_going_down.gif",
        "name": "Yoyo Going Down",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "270", "scaleFrq": "0", "rotateFrq": "1", "rotateType": "fixed", "rotations": "2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "coin_flip_upward.gif",
        "name": "Coin Flip Upward",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "45", "scaleFrq": "0", "rotateFrq": "1", "rotateType": "fixed", "rotations": "-2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "roll_down_the_hill.gif",
        "name": "Roll Down the Hill",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "315", "scaleFrq": "0", "rotateFrq": "1", "rotateType": "fixed", "rotations": "-2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "rolling_up_the_hill.gif",
        "name": "Roll Up the Hill",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_left_in.gif",
        "name": "Curve Left In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "180", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_right_in.gif",
        "name": "Curve Right In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "90", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_top_in.gif",
        "name": "Curve Top In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "270", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_bottom_in.gif",
        "name": "Curve Bottom In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "45", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_upper_left_in.gif",
        "name": "Curve Upper Left In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "135", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_upper_right_in.gif",
        "name": "Curve Upper Right In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "315", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_lower_left_in.gif",
        "name": "Curve Lower Left In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "225", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_lower_right_in.gif",
        "name": "Curve Lower Right In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_left_in.gif",
        "name": "Boomerang Left In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "180", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_right_in.gif",
        "name": "Boomerang Right In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "90", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_top_in.gif",
        "name": "Boomerang Top In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "270", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_bottom_in.gif",
        "name": "Boomerang Bottom In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "45", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_upper_left_in.gif",
        "name": "Boomerang Upper Left In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "135", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_upper_right_in.gif",
        "name": "Boomerang Upper Right In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "315", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_lower_left_in.gif",
        "name": "Boomerang Lower Left In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "225", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_lower_right_in.gif",
        "name": "Boomerang Lower Right In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "0", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "scale_in.gif",
        "name": "Scale In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "1", "blurValue": "20", "textTypingFrq": "0"}},
        "image": "blur_in.gif",
        "name": "Blur In",
        "mode": "In"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "0", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "10", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "spin_cycle_in.gif",
        "name": "Spin Cycle In",
        "mode": "In"
    }, {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "0", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "10", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "1"}},
        "image": "typewritter.gif",
        "name": "Typewritter (components with text only)",
        "mode": "In"
    },
];

export const OutAnimations: Array<IAnimationPreset> = [
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "0", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_out.gif",
        "name": "Fade Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "270", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "exit_to_top.gif",
        "name": "Exit to Top",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "90", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "exit_to_bottom.gif",
        "name": "Exit to Bottom",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "180", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "exit_to_left.gif",
        "name": "Exit to Left",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "exit_to_right.gif",
        "name": "Exit to Right",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "225", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "exit_to_upper_left_corner.gif",
        "name": "Exit to Upper Left Corner",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "315", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "exit_to_upper_right_corner.gif",
        "name": "Exit to  Upper Right  Corner",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "135", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "exit_to_lower_left_corner.gif",
        "name": "Exit to  Lower Left Corner",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "45", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "exit_to_lower_left_right_corner.gif",
        "name": "Exit to  Lower Right Corner",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "270", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_out_to_top.gif",
        "name": "Fade Out to Top",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "90", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_out_to_bottom.gif",
        "name": "Fade Out to Bottom",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "180", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_out_to_left.gif",
        "name": "Fade Out to Left",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_out_to_right.gif",
        "name": "Fade Out to Right",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "225", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_out_to_ne.gif",
        "name": "Fade Out to NE",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "315", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_out_to_nw.gif",
        "name": "Fade Out to NW",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "135", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_out_to_se.gif",
        "name": "Fade Out to SE",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "45", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "fade_out_to_sw.gif",
        "name": "Fade Out to SW",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "0", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "spiral_out_counter_clockwise.gif",
        "name": "Spiral Out Counter Clockwise",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "180", "scaleFrq": "0", "rotateFrq": "1", "rotateType": "fixed", "rotations": "2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "roll_out_to_left.gif",
        "name": "Roll Out to Left",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "0", "rotateFrq": "1", "rotateType": "fixed", "rotations": "-2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "roll_out_to_right.gif",
        "name": "Roll Out to Right",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "270", "scaleFrq": "0", "rotateFrq": "1", "rotateType": "fixed", "rotations": "2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "yoyo_going_up.gif",
        "name": "Yoyo Going Up",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "90", "scaleFrq": "0", "rotateFrq": "1", "rotateType": "fixed", "rotations": "2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "coin_flip_downward.gif",
        "name": "Coin Flip Downward",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "45", "scaleFrq": "0", "rotateFrq": "1", "rotateType": "fixed", "rotations": "-2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "roll_off_the_hill.gif",
        "name": "Roll Off the Hill",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "315", "scaleFrq": "0", "rotateFrq": "1", "rotateType": "fixed", "rotations": "-2", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "roll_further_up_the_hill.gif",
        "name": "Roll Further Up the Hill",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "180", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_left_out.gif",
        "name": "Curve Left Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_right_out.gif",
        "name": "Curve Right Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "270", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_top_out.gif",
        "name": "Curve Top Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "90", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_bottom_out.gif",
        "name": "Curve Bottom Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "225", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_upper_left_out.gif",
        "name": "Curve Upper Left Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "315", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_upper_right_out.gif",
        "name": "Curve Upper Right Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "135", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_lower_left_out.gif",
        "name": "Curve Lower Left Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "45", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "curve_lower_right_out.gif",
        "name": "Curve Lower Right Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "180", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_left_out.gif",
        "name": "Boomerang Left Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_right_out.gif",
        "name": "Boomerang Right Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "270", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_top_out.gif",
        "name": "Boomerang Top Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "90", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_bottom_out.gif",
        "name": "Boomerang Bottom Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "225", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_upper_left_out.gif",
        "name": "Boomerang Upper Left Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "315", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_upper_right_out.gif",
        "name": "Boomerang Upper Right Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "135", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_lower_left_out.gif",
        "name": "Boomerang Lower Left Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1500", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "2", "moveDir": "fixed", "moveAngle": "45", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "boomerang_lower_right_out.gif",
        "name": "Boomerang Lower Right Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "1", "moveFrq": "0", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "1", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "scale_out.gif",
        "name": "Scale Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "1", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "1", "blurFrq": "1", "blurValue": "20", "textTypingFrq": "0"}},
        "image": "blur_out.gif",
        "name": "Blur Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "0", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "1", "rotateFrq": "1", "rotateType": "fixed", "rotations": "10", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "0"}},
        "image": "spin_cycle_out.gif",
        "name": "Spin Cycle Out",
        "mode": "Out"
    },
    {
        "animation": {"$": {"enabled": "1", "delay": "0", "duration": "1000", "fadeFrq": "0", "moveFrq": "0", "moveIntense": "1", "moveDir": "fixed", "moveAngle": "0", "scaleFrq": "0", "rotateFrq": "0", "rotateType": "fixed", "rotations": "10", "blurFrq": "0", "blurValue": "10", "textTypingFrq": "1"}},
        "image": "backspace.gif",
        "name": "Backspace (components with text only)",
        "mode": "Out"
    },
];